module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "ct",
    attrs: {
      "id": "toc_marker-3"
    }
  }, [_c('a', {
    attrs: {
      "id": "Contents-A"
    }
  }, [_vm._v("Contents")])]), _c('a', {
    attrs: {
      "id": "Contents-A"
    }
  })]), _c('a', {
    attrs: {
      "id": "Contents-A"
    }
  }), _c('div', [_c('a', {
    attrs: {
      "id": "Contents-A"
    }
  }, [_c('p', {
    staticClass: "ct"
  })]), _c('p', {
    staticClass: "Contents-Entry"
  }, [_c('a', {
    attrs: {
      "id": "Contents-A"
    }
  }), _c('a', {
    attrs: {
      "href": "#/The_Spirit_and_the_Skull#toc_marker-1"
    }
  }, [_vm._v("The Spirit and the Skull")])]), _vm._v(" "), _c('p', {
    staticClass: "Contents-Entry"
  }, [_c('a', {
    attrs: {
      "href": "#/The_Spirit_and_the_Skull1#toc_marker-2"
    }
  }, [_vm._v("Copyright")])]), _vm._v(" "), _c('p', {
    staticClass: "Contents-Entry"
  }, [_c('a', {
    attrs: {
      "href": "#/#toc_marker-3"
    }
  }, [_vm._v("Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "Contents-Entry"
  }, [_c('a', {
    attrs: {
      "href": "#/The_Spirit_and_the_Skull3#toc_marker-4"
    }
  }, [_vm._v("Dedication")])]), _vm._v(" "), _c('p', {
    staticClass: "Contents-Entry"
  }, [_c('a', {
    attrs: {
      "href": "#/The_Spirit_and_the_Skull4#toc_marker-5"
    }
  }, [_vm._v("Epigraph")])]), _vm._v(" "), _c('p', {
    staticClass: "Contents-Entry"
  }, [_c('a', {
    attrs: {
      "href": "#/The_Spirit_and_the_Skull5#toc_marker-6"
    }
  }, [_vm._v("Unthinkable")])]), _vm._v(" "), _c('p', {
    staticClass: "Contents-Entry"
  }, [_c('span', {
    attrs: {
      "href": "#/The_Spirit_and_the_Skull6#toc_marker-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hunt")])]), _vm._v(" "), _c('p', {
    staticClass: "Contents-Entry"
  }, [_c('span', {
    attrs: {
      "href": "#/The_Spirit_and_the_Skull7#toc_marker-8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Discoveries")])]), _vm._v(" "), _c('p', {
    staticClass: "Contents-Entry"
  }, [_c('span', {
    attrs: {
      "href": "#/The_Spirit_and_the_Skull8#toc_marker-9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Trial")])]), _vm._v(" "), _c('p', {
    staticClass: "Contents-Entry"
  }, [_c('span', {
    attrs: {
      "href": "#/The_Spirit_and_the_Skull9#toc_marker-10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Interlude")])]), _vm._v(" "), _c('p', {
    staticClass: "Contents-Entry"
  }, [_c('span', {
    attrs: {
      "href": "#/The_Spirit_and_the_Skull10#toc_marker-11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Flesh")])]), _vm._v(" "), _c('p', {
    staticClass: "Contents-Entry"
  }, [_c('span', {
    attrs: {
      "href": "#/The_Spirit_and_the_Skull11#toc_marker-12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ivory")])]), _vm._v(" "), _c('p', {
    staticClass: "Contents-Entry"
  }, [_c('span', {
    attrs: {
      "href": "#/The_Spirit_and_the_Skull12#toc_marker-13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figurine")])]), _vm._v(" "), _c('p', {
    staticClass: "Contents-Entry"
  }, [_c('span', {
    attrs: {
      "href": "#/The_Spirit_and_the_Skull13#toc_marker-14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Bear of the Cave Clan")])]), _vm._v(" "), _c('p', {
    staticClass: "Contents-Entry"
  }, [_c('span', {
    attrs: {
      "href": "#/The_Spirit_and_the_Skull14#toc_marker-15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Caught")])]), _vm._v(" "), _c('p', {
    staticClass: "Contents-Entry"
  }, [_c('span', {
    attrs: {
      "href": "#/The_Spirit_and_the_Skull15#toc_marker-16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ice Eyes")])]), _vm._v(" "), _c('p', {
    staticClass: "Contents-Entry"
  }, [_c('span', {
    attrs: {
      "href": "#/The_Spirit_and_the_Skull16#toc_marker-17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Traps")])]), _vm._v(" "), _c('p', {
    staticClass: "Contents-Entry"
  }, [_c('span', {
    attrs: {
      "href": "#/The_Spirit_and_the_Skull17#toc_marker-18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Questions Without Answers")])]), _vm._v(" "), _c('p', {
    staticClass: "Contents-Entry"
  }, [_c('span', {
    attrs: {
      "href": "#/The_Spirit_and_the_Skull18#toc_marker-19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Journey to a Confession")])]), _vm._v(" "), _c('p', {
    staticClass: "Contents-Entry"
  }, [_c('span', {
    attrs: {
      "href": "#/The_Spirit_and_the_Skull19#toc_marker-20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Facts and Fictions")])]), _vm._v(" "), _c('p', {
    staticClass: "Contents-Entry"
  }, [_c('span', {
    attrs: {
      "href": "#/The_Spirit_and_the_Skull20#toc_marker-21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("In the World of the Dead")])]), _vm._v(" "), _c('p', {
    staticClass: "Contents-Entry"
  }, [_c('span', {
    attrs: {
      "href": "#/The_Spirit_and_the_Skull21#toc_marker-22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Confrontation")])]), _vm._v(" "), _c('p', {
    staticClass: "Contents-Entry"
  }, [_c('span', {
    attrs: {
      "href": "#/The_Spirit_and_the_Skull22#toc_marker-23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Mother’s Wisdom")])]), _vm._v(" "), _c('p', {
    staticClass: "Contents-Entry"
  }, [_c('span', {
    attrs: {
      "href": "#/The_Spirit_and_the_Skull23#toc_marker-24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Afterword & Acknowledgements")])]), _vm._v(" "), _c('p', {
    staticClass: "Contents-Entry"
  }, [_c('span', {
    attrs: {
      "href": "#/The_Spirit_and_the_Skull24#toc_marker-25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("More from this Author")])]), _vm._v(" "), _c('p', {
    staticClass: "Contents-Entry"
  }, [_c('span', {
    attrs: {
      "href": "#/The_Spirit_and_the_Skull25#toc_marker-26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Contact Us")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-93d98178","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/The_Spirit_and_the_Skull2.vue
// module id = 66
// module chunks = 0